module.exports = __webpack_public_path__ + "bin/6c01265b861272b6f20a79e1ec732978.jpg";